import { useCallback } from 'react'

import html2canvas from 'html2canvas'
import BridgeService from 'common/services/bridgeService'
import { _try } from 'common/utils/errorUtils'
import { useErrorHandler } from 'react-error-boundary'

interface UseShareElementAsImageReturn {
  shareElement: (elementId: string) => void
}

export function useShareElementAsImage(errorCodeRef: string): UseShareElementAsImageReturn {
  const handleError = useErrorHandler()

  const shareElement = useCallback(
    (elementId: string) =>
      _try(
        async () => {
          const element = document.getElementById(elementId)
          if (!element) {
            return
          }

          const scale = window.devicePixelRatio
          const canvas = await html2canvas(element, {
            scale,
            useCORS: true,
            allowTaint: true,
            logging: true,
            windowWidth: element.scrollWidth * scale,
            windowHeight: element.scrollHeight * scale,
          })

          const dataUrl = canvas.toDataURL('image/jpeg', 1.0)
          const base64 = dataUrl.replace(/^data:image\/\w+;base64,/, '')
          await BridgeService.shareImageAction(base64)
        },
        handleError,
        errorCodeRef,
      ),
    [handleError, errorCodeRef],
  )

  return { shareElement }
}
